import React, { useContext } from 'react'
import { sliderItems } from '@/dummydata'
import { UserContext, CartContext } from '@/App'
import ForgotPasswordForm from "@/ui/ForgotPasswordForm"
import ChangePasswordForm from "@/ui/ChangePasswordForm"
import api from '@/api'
import { useNavigate } from 'react-router-dom'

export default function ForgotPasswordPage() {
    const {cart} = useContext(CartContext)
    const {user,setUser} = useContext(UserContext)
    const navigate = useNavigate()
    const token = new URLSearchParams(window.location.search).get("a");

    const handleForgot = async userData => {
        const resp = await api.forgotPassword(userData)
        if (resp.status == "ok") {
            alert("link sent to mail");
        }
        return resp
    }

    const handleChangePassword = async userData =>{
        console.log("token",token)
        console.log("userdata",userData)
        const resp = await api.resetPassword({    
        token: token,
        password: userData.confirmPassword})
         if(resp.success){
		console.log(resp);
        navigate("/login")
		// window.location.reload();
		 }
    }
    const randomSlide = sliderItems[Math.floor(Math.random() * sliderItems.length)]

    return (
        <main 
            className="flex justify-center h-screen items-center bg-cover bg-center sm:bg-left"
            style={{backgroundImage: `url(${randomSlide.image})`}}
        >
            <div className="min-w-sm p-6 rounded-lg bg-white filter drop-shadow-2xl">
                <h3 className="text-2xl font-bold text-center mb-6">Change Password</h3>
                
                {token
                ? <ChangePasswordForm onSubmit={handleChangePassword}/>
                :<ForgotPasswordForm onSubmit={handleForgot} />
                }
            </div>
        </main>
    )
}